export const BG_TASK_TYPES = {
    GenerateReport: "GenerateReport",
    DownloadGeneratedReport: "DownloadGeneratedReport",
};

type Keys = keyof typeof BG_TASK_TYPES;
export type BgTaskTypeValues = (typeof BG_TASK_TYPES)[Keys];
